import { Dispatch, SetStateAction } from 'react';

import { InboxOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { Upload, message } from 'antd';

const { Dragger } = Upload;

const ALLOWED_MIME_TYPES = [
	'text/plain',
	'text/csv',
	'text/tab-separated-values',
];

interface IProps {
	uploadedFile: UploadFile<any> | null;
	setUploadedFile: Dispatch<SetStateAction<UploadFile<any> | null>>;
	setContent: Dispatch<SetStateAction<string>>;
}

function FileUpload({ uploadedFile, setUploadedFile, setContent }: IProps) {
	const props: UploadProps = {
		name: 'file',
		multiple: false,

		accept: '.txt',
		beforeUpload: () => {
			return false;
		},
		maxCount: 1,
		onChange(info) {
			const { status } = info.file;

			if (status !== 'uploading') {
				// setContent('');
				setUploadedFile(info.fileList?.[0]);

				const reader = new FileReader();
				reader.onload = (event) => {
					setContent(event.target?.result as string);
				};

				if (info.fileList?.[0]?.originFileObj) {
					reader.readAsText(info.fileList?.[0]?.originFileObj);
				} else {
					setContent('');
				}
			}
		},
		onDrop(e) {
			const droppedFile = e.dataTransfer.files?.[0];
			if (!ALLOWED_MIME_TYPES.includes(droppedFile.type)) {
				message.warning('This file type is not allowed');
			}

			if (e.dataTransfer.files.length > 1) {
				message.warning('Single *.txt file allowed');
			}
		},
		onRemove() {
			setUploadedFile(null);
			setContent('');
		},
	};

	return (
		<Dragger {...props} fileList={uploadedFile ? [uploadedFile] : []}>
			<p className="ant-upload-drag-icon">
				<InboxOutlined />
			</p>
			<p className="ant-upload-text">
				Click or drag file to this area to upload
			</p>
			<p className="ant-upload-hint">Accepts single *.txt file.</p>
		</Dragger>
	);
}

export default FileUpload;
